<template>
  <div class="middleView">
    <!-- 时空业务中台 -->
    <div class="midT">
        <img class="image" src="./img/middleA.png" alt="">
    </div>
    <div class="caption">
        <img class="image" src="./img/middleB.png" alt="">
    </div>
    <div class="explain midTitle">
        <img class="image" src="./img/middleC.png" alt="">
    </div>
    <div class="explain midTitle">
        <img class="image" src="./img/middleD.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'middleView'
}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.midTitle{
   padding-left: 30px/$md;
   padding-right: 30px/$md;
}
.caption{
    width: 250px/$md;
    height: 107px/$md;
    margin: 50px/$md auto;
}
.explain{
    margin-bottom: 30px/$md;
}
.image{
    width:100%;
    height: 100%;
}
</style>
